//gsap.to()... infinity and beyond!

//To learn more about using GreenSock's bonus plugins for free on CodePen visit: https://gsap.com/trial

let cards = gsap.utils.toArray(".card");
let animation = gsap.timeline();

// Pre-measure card heights before any positioning
let maxCardHeight = 0;
let contentHeight = 0;

function measureHeights() {
	// Get the block element and content column
	const block = document.querySelector('.wp-block-create-block-card-test');
	const contentColumn = block.querySelector('.vertical-card-slider__content-column');

	// Measure content height
	contentHeight = contentColumn ? contentColumn.offsetHeight : 0;

	// Find the tallest card by measuring their content
	cards.forEach((card, index) => {
		// Use scrollHeight to get natural content height
		const naturalHeight = card.scrollHeight;
		const offsetHeight = card.offsetHeight;
		if (naturalHeight > maxCardHeight) {
			maxCardHeight = naturalHeight;
		}
	});
}

function initCards() {
	animation.clear();

	// Check if mobile (< 1024px)
	const isMobile = window.innerWidth < 1024;

	// Heights are already measured, just apply them
	// On mobile: use only maxCardHeight, ignore contentHeight
	// On desktop: use max of contentHeight and maxCardHeight
	const finalCardHeight = isMobile ? maxCardHeight : Math.max(contentHeight, maxCardHeight);

	// Apply the height to all cards
	cards.forEach((card) => {
		card.style.height = `${finalCardHeight}px`;
	});

	// Set the #cards container height to match
	const cardsContainer = document.getElementById('cards');
	if (cardsContainer) {
		cardsContainer.style.height = `${finalCardHeight}px`;
	}

	// Refresh ScrollTrigger to recalculate positions after dynamic height changes
	requestAnimationFrame(() => {
		ScrollTrigger.refresh();
	});

	// Set initial positions - first card visible, others below viewport
	cards.forEach((card, index) => {
		if (index === 0) {
			// First card starts visible at the top
			gsap.set(card, {
				y: 0,
				zIndex: 1 // Base layer
			});
		} else {
			// Other cards start below viewport with more spacing
			gsap.set(card, {
				y: window.innerHeight + (index * 100), // More spacing between cards
				zIndex: index + 1 // Higher z-index for cards that stack on top
			});
		}
	});

	// Create the upward card animation (skip first card since it's already visible)
	// Limit to maximum 6 cards for animation
	const maxCards = Math.min(cards.length, 6);
	for (let i = 1; i < maxCards; i++) {
		const card = cards[i];
		const previousCard = cards[i - 1];

		// Each subsequent card animates up to its final stacked position
		animation.to(card, {
			y: (i - 1), // Perfect overlap - each card sits exactly on previous card
			duration: 0.8,
			ease: "power2.out",
			onUpdate: function() {
				if (previousCard && this.progress() >= 0.5) {
					previousCard.style.setProperty('--before-opacity', '0');
				} else if (previousCard && this.progress() < 0.5) {
					previousCard.style.setProperty('--before-opacity', '1');
				}
			}
		}, (i - 1) * 1.0); // Wait for each card animation to complete before next starts
	}

	// Calculate end position based on animation duration
	// Each card animation takes 0.8s, staggered by 1.0s
	// For N cards, we have (N-1) animations, last one ends at (N-2)*1.0 + 0.8
	const animationDuration = maxCards > 1 ? ((maxCards - 2) * 1.0) + 0.8 : 0;

	// Set start position based on screen size
	const currentIsMobile = window.innerWidth < 1024;
	const startPosition = currentIsMobile ? `${contentHeight - 40}px top` : "-125px top";

	ScrollTrigger.create({
		trigger: ".wp-block-create-block-card-test",
		start: startPosition, // Mobile: start after content, Desktop: 125px before
		end: `+=${animationDuration * 100}%`, // End when last card animation completes
		pin: ".wp-block-create-block-card-test",
		scrub: 1,
		animation: animation,
		pinSpacing: true,
		markers: false,
		invalidateOnRefresh: true,
		ease: "none"
	});
}

/**
 * Initialize when DOM is ready - only if the block exists on the page
 */
function initializeCardTest() {
	// Check if the card-test block exists on this page
	const blockExists = document.querySelector('.wp-block-create-block-card-test');

	if (!blockExists) {
		// Block is not on this page, skip initialization
		return;
	}

	measureHeights(); // Measure first
	initCards(); // Then initialize animation
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		// Use requestAnimationFrame to ensure elements are fully rendered
		requestAnimationFrame(() => {
			initializeCardTest();
		});
	});
} else {
	// Use requestAnimationFrame to ensure elements are fully rendered
	requestAnimationFrame(() => {
		initializeCardTest();
	});
}